<template>
    <v-dialog v-model="isVisible" persistent max-width="1000">
        <v-toolbar dark color="primary" >
            <v-icon>edit</v-icon>
            <v-toolbar-title class="white--text" >Edit Report Settings</v-toolbar-title>
                <v-spacer></v-spacer>

            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs
            v-model="tab"
            centered
            dark
            color="primary">
            <v-tab href="#tab-settings">
                Settings
            </v-tab>
            <v-tab href="#tab-layout">
                Layout
            </v-tab>
            <v-tab href="#tab-text">
                Text
            </v-tab>
            
        </v-tabs>
        <v-card >
            <v-card-text>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-settings">
                        <v-container grid-list-xl>
                            <v-form ref="form" v-model="isValid" lazy-validation>
                                <v-layout wrap justify-space-between>
                                    <v-flex xs12>
                                         <v-select
                                            :items="users"
                                             item-text="username"
                                            item-value="_id"
                                            v-model="report.users"
                                            :menu-props="{ maxHeight: '400' }"
                                            label="Select"
                                            multiple
                                            hint="Pick Users for this Report"
                                            persistent-hint></v-select>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                         <v-checkbox
                                            label="Decouple report from season selection and load all data. (Slower)"
                                            v-model="report.settings.decoupleFromSeasonSelection"></v-checkbox>
                                        <v-checkbox
                                            label="Show column grand totals"
                                            v-model="report.settings.showColumnGrandTotals"></v-checkbox>
                                        <v-checkbox
                                            label="Show row grand totals"
                                            v-model="report.settings.showRowGrandTotals"></v-checkbox>
                                        <v-checkbox
                                            label="Show row totals"
                                            v-model="report.settings.showRowTotals"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-checkbox
                                            label="Show column totals"
                                            v-model="report.settings.showColumnTotals"></v-checkbox>
                                        <v-checkbox
                                            label="Field chooser enabled"
                                            v-model="report.settings.isFieldChooserEnabled"></v-checkbox>
                                        <v-checkbox
                                            label="Excel Export enabled"
                                            v-model="report.settings.isExcelExportEnabled"></v-checkbox>
                                        <v-checkbox
                                            label="Enable sorting"
                                            v-model="report.settings.isSortingEnabled"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item value="tab-layout">
                        <v-container grid-list-xl>
                            <v-form ref="form" v-model="isValid" lazy-validation>
                                <v-layout wrap justify-space-between>
                                    <v-flex xs12 md6>
                                        <v-checkbox
                                            label="Show borders"
                                            v-model="report.settings.showBorders"></v-checkbox>
                                        <v-checkbox
                                            label="Right to left mode"
                                            v-model="report.settings.rtlEnabled"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                      <v-checkbox
                                            label="Tree row header layout"
                                            v-model="report.settings.showRowHeaderAsTree"></v-checkbox>
                                        <v-checkbox
                                            label="Show field panel"
                                            v-model="report.settings.isFieldPanelVisible"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item value="tab-text">
                        <h3>Caption</h3>
                        <v-text-field
                            v-model="report.settings.caption.en"
                            label="Caption english"></v-text-field>
                        <v-text-field
                            v-model="report.settings.caption.de"
                            label="Caption german"></v-text-field>
                        <h3>Description</h3>
                        <v-text-field
                            v-model="report.settings.description.en"
                            label="Description english"></v-text-field>
                        <v-text-field
                            v-model="report.settings.description.de"
                            label="Description german"></v-text-field>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        report: {
            type: Object,
            required: true
        }
    },
    components: {
        
    },
    computed: {
        ...mapGetters([
            'users'
        ]),
    },
    data() {
        return {
            tab: 'tab-settings',
            isValid: true
        }
    },
	methods: {
        close () {
            this.$emit('close')
        }
	}
};
</script>
<style>

	.vue-grid-item.vue-grid-placeholder {
        background-color: rgb(53, 53, 53);
    }

    .widget-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: .5s ease;
        background: #464c69;
         /* filter:blur(4px);
        -o-filter:blur(4px);
        -ms-filter:blur(4px);
        -moz-filter:blur(4px);
        -webkit-filter:blur(4px); */
    }

    .widget-container:hover .widget-overlay {
        opacity: 0.8;
    }
</style>